"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Edit = function Edit(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({}, props), {}, {
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      children: title
    }) : null, (0, _jsxRuntime.jsx)("circle", {
      cx: "16",
      cy: "16",
      r: "16",
      fill: "#1C70F2",
      fillOpacity: "0.1"
    }), (0, _jsxRuntime.jsx)("mask", {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "9",
      y: "7",
      width: "15",
      height: "17",
      children: (0, _jsxRuntime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.916 12.7828L18.1044 11.3575L19.2918 9.84754L21.1039 11.2733L19.916 12.7828ZM14.479 19.6924L12.0585 20.9045L12.6674 18.2666L16.9164 12.8671L18.7274 14.2929L14.479 19.6924ZM22.9522 10.2834L19.8191 7.81813C19.3507 7.44919 18.6712 7.53024 18.3022 7.99919L11.0417 17.226C10.9428 17.3518 10.8733 17.4966 10.8375 17.6518L9.78486 22.2129C9.68223 22.6581 9.86171 23.0629 10.1696 23.305C10.477 23.5471 10.9133 23.6271 11.3217 23.4218L15.507 21.3255C15.6496 21.255 15.7743 21.1529 15.8722 21.0281L23.1328 11.8008C23.5022 11.3318 23.4212 10.6523 22.9522 10.2834Z",
        fill: "white"
      })
    }), (0, _jsxRuntime.jsx)("g", {
      mask: "url(#mask0)",
      children: (0, _jsxRuntime.jsx)("rect", {
        x: "-22.4727",
        y: "-22.421",
        width: "78.814",
        height: "78.9474",
        fill: "#1C70F2"
      })
    })]
  }));
};

var _default = Edit;
exports["default"] = _default;